module.exports = __webpack_public_path__ + "common-white-sovos-shipcompliant-logo.svg";